import React, { useEffect, useState } from 'react';
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import GridLoader from "src/control-components/loader/loader";
import { ClientService } from "../../services/clientService";
import DropDownKendoRct from "../../control-components/drop-down/drop-down";
import { renderErrors } from "src/helper/error-message-helper";
import apiHelper from "src/helper/api-helper";
import API_URLS from "src/helper/api-urls";
import NotificationManager from "react-notifications/lib/NotificationManager";
import { DropDownObjectWithString } from 'src/dataModels/docListModel';
import { filterBy } from '@progress/kendo-data-query';
import { DropDownObjectWithNumber } from 'src/dataModels/docListModel';

const AssignSupervisor = ({ selectedDocumentId, selectedSupervisorId, handleAssignSupervisorClose, fetchByDocumentId, title }) => {
    const [staffDataList, setStaffDataList] = useState([]);
    const [loading, setLoading] = useState(false);
    const [defaultSelectedvalue, setDefaultSelectedvalue] = useState<DropDownObjectWithNumber>();
    const [filter, setFilter] = useState<any>();

    useEffect(() => {
        getStaffList();

    }, []);

    const getStaffList = async () => {
        setLoading(true);
        await ClientService.getStaffDDLByClinicId().then((result) => {
            let list = result.resultData;
            setStaffDataList(list);
            setLoading(false);
            var selectedStaff = result?.resultData?.filter((item) => item.id == selectedSupervisorId);
            const defaultItem: DropDownObjectWithNumber = {
                name: selectedStaff[0]?.name,
                id: selectedSupervisorId
            };
            setDefaultSelectedvalue(defaultItem);
        }).catch((error) => {
            setLoading(false);
            renderErrors(error);
        });
    };
    const handleSubmit = () => {
        setLoading(true);
        var postData = {
            "supervisorStaffId": defaultSelectedvalue?.id,
            "documentIds": [selectedDocumentId]
        };
        apiHelper.postRequest(API_URLS.ASSIGN_SIPERVISOR, postData).then((result) => {
            setLoading(false);
            NotificationManager.success("Supervisor assigned successfully");
            handleAssignSupervisorClose();
            fetchByDocumentId(selectedDocumentId);
        }).catch((err) => {
            renderErrors(err);
        }).finally(() => {
            setLoading(false);
        });

    }
    const onStaffDDLChange = (e) => {
        setDefaultSelectedvalue(e.target?.value);
    }

    return (
        <Dialog
            onClose={handleAssignSupervisorClose}
            title={title}
            className='xs-modal '
            width={"30%"}
            height={"20%"}
        >
            {loading && <GridLoader />}
            <div>

                <DropDownKendoRct
                    label="Staff:"
                    data={filterBy(staffDataList, (filter && filter.staffDataList) ? filter.staffDataLis : [])}
                    textField="name"
                    dataItemKey="id"
                    onChange={onStaffDDLChange}
                    suggest={true}
                    name="defaultSelectedvalue"
                    placeholder={"Staff"}
                    value={defaultSelectedvalue}
                />
            </div>
            <DialogActionsBar>
                <button className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base textWhite blue-primary text-white" onClick={handleSubmit}>Submit</button>
                <button className=" k-button-md k-rounded-md k-button-solid k-button-solid-base grey-secondary sealBtn " onClick={handleAssignSupervisorClose}>Cancel</button>
            </DialogActionsBar>
        </Dialog>
    )
};

export default AssignSupervisor

